import React from "react";
import { LanguageSelection } from "./components/TTS/LanguageSelection";

function App() {
  // console.log(value);
  return (
    <div className="App">
      <LanguageSelection/>
      {/* <div>
        {value}
      </div> */}
    </div>
  );
}

export default App;
